(function () {
  angular
    .module('specsguardApp')
    .directive('sgTableRadioButtonFilter', sgTableRadioButtonFilter);

  sgTableRadioButtonFilter.$inject = [];

  function sgTableRadioButtonFilter () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table-radio-button-filter/sg-table-radio-button-filter.html'
    };
  };
})();
